import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';

export default class InfoBubble extends React.Component {
    render() {
        const color = this.props.color;
        const description = this.props.description;

        return (
            <Flex basis='30%' hAlignContent='center'>
                <Flex column hAlignContent='center' vAlignContent='center' className={style.Wrap} style={{border: `4px solid ${color}`}}>
                    <Flex className={style.Heading}>
                        <Flex className={style.HeadingText}>{this.props.HeadingText}</Flex>
                    </Flex>
                    <Flex className={style.Description} hAlignContent='center'>
                    {description}
                    </Flex>
                </Flex>
            </Flex>
        );

    }
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/CompanySettings/Installation/InfoBubble/index.js